import { createAuth0Client } from '@auth0/auth0-spa-js';

let auth0Client = null;

export async function initAuth0({ domain, clientId, redirectUri }) {
  if (auth0Client) return auth0Client;

  if (!domain || !clientId) {
    throw new Error('Auth0 not configured');
  }

  auth0Client = await createAuth0Client({
    domain,
    clientId,
    authorizationParams: {
      redirect_uri: redirectUri,
      scope: 'openid profile email',
    },
  });

  const params = new URLSearchParams(window.location.search);
  if (params.has('code') && params.has('state')) {
    await auth0Client.handleRedirectCallback();
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  return auth0Client;
}

// Fonction pour lire les claims
export async function getIdTokenClaims() {
  if (!auth0Client) return null;
  return auth0Client.getIdTokenClaims();
}

export async function signupWithAuth0(config) {
  const client = await initAuth0(config);
  return client.loginWithRedirect({
    authorizationParams: {
      prompt: 'login', // Clear Cache Auth0 on every login
      screen_hint: 'signup', // Type of form
      ui_locales: config.locale, // Auth0 custom variables must have same language
      'ext-promoCode': config.promoCode, // Code Promo
      'ext-productSource': config.productSource, // Code Product Source
    },
  });
}
